'use client';
import {useEffect} from 'react';
import {setPageRegisterInterestContext} from './page-register-interest-context';

interface PageRegisterInterestContextProps {
  projectId?: string;
  phaseId?: string;
  designTypeId?: string;
}

// Renders nothing; mount it inside a detail page's JSX so the layout-level
// register-interest entry points (header CTA, burger-menu CTA, mobile sticky
// bar) open pre-filled with that page's project for as long as it is on screen.
export function PageRegisterInterestContext({projectId, phaseId, designTypeId}: PageRegisterInterestContextProps) {
  useEffect(() => setPageRegisterInterestContext({projectId, phaseId, designTypeId}), [projectId, phaseId, designTypeId]);
  return null;
}

PageRegisterInterestContext.displayName = 'PageRegisterInterestContext';
